import roundEther from "@/common/filters/roundEther";
import privatizeAddress from "@/common/filters/privatizeAddress";

export default {
  roundEther,
  privatizeAddress,
};
